/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `ESTIMATE` - TRANSPORT_COST_ESTIMATE
 * * `LOGISTICS_QUOTE` - LOGISTICS_QUOTE
 * * `OTHER` - OTHER
 */
export type SourceChoiceEnum = typeof SourceChoiceEnum[keyof typeof SourceChoiceEnum];


export const SourceChoiceEnum = {
  ESTIMATE: 'ESTIMATE',
  LOGISTICS_QUOTE: 'LOGISTICS_QUOTE',
  OTHER: 'OTHER',
} as const;
